module.exports = __webpack_public_path__ + "img/1554758745.2014fdc5.jpg";